import {useEffect, useRef, useState} from 'react'
import {API_URL, GOOGLE_CLIENT_ID} from '../constants/constants'

declare const google: any

interface LoginProps {
    onSuccess: () => void
}

export const Login = ({onSuccess}: LoginProps) => {
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const buttonRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        google.accounts.id.initialize({
            client_id: GOOGLE_CLIENT_ID,
            callback: handleCredentialResponse,
        })

        google.accounts.id.renderButton(buttonRef.current, {
            theme: 'outline',
            size: 'large',
            width: 300,
        })
    }, [])

    const handleCredentialResponse = async (response: { credential: string }) => {
        setLoading(true)
        setError('')

        try {
            const res = await fetch(`${API_URL}/auth/google`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({idToken: response.credential}),
            })

            const data = await res.json()

            if (!res.ok) {
                throw new Error(data.message || 'Ошибка авторизации')
            }

            localStorage.setItem('accessToken', data.accessToken)
            onSuccess()
        } catch (e: any) {
            setError(e.message || 'Ошибка авторизации')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="container">
            <div className="form-wrapper">
                <div ref={buttonRef} style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}></div>
                {loading && <p>Авторизация...</p>}
                {error && <div className="error-message">{error}</div>}
            </div>
        </div>
    )
}
